import * as React from 'react';
import {NavLink} from 'react-router-dom';


interface LinkProps{
	to: string;
	title: string;
	id: string;
	className?: string;
	style?: any;
	children: any;
}


export class Link extends React.Component<LinkProps>{
	render(){
		return this.props.to
			? <NavLink {...this.props}/>
			: <a {...this.props}/>;
	}
}
export default Link;